// The release a Power process runs (its `SERVICE_VERSION`), as stamped on the
// evidence it writes: non-empty, bounded, branded so no other text stands in.
import { Schema } from 'effect';

const RELEASE_VERSION_MAX_LENGTH = 64;

export const ReleaseVersion = Schema.NonEmptyString.check(
  Schema.isMaxLength(RELEASE_VERSION_MAX_LENGTH),
).pipe(Schema.brand('ReleaseVersion'));
export type ReleaseVersion = typeof ReleaseVersion.Type;
